module.exports = require("./sw-CD.d.ts");